export const filterElementsBySize = (arr) => {
    const sizeThreshold = 250;
    const aspectRatioThreshold = 1.6;
    return arr.filter((el) => {
        const aspectRatio = el.width / el.height;
        const isWithinAspectRange = aspectRatio <= aspectRatioThreshold && aspectRatio >= 1 / aspectRatioThreshold;
        const isLargeEnough = el.width >= sizeThreshold || el.height >= sizeThreshold;
        return isLargeEnough && isWithinAspectRange;
    });
};
